module.exports = __webpack_public_path__ + "static/media/header_right.7918535d.svg";